import { Text } from 'components/ui/typography/Text';
import styled from 'styled-components';

export const StyledText = styled(Text)`
    word-wrap: break-word;
    width: 100%;
`;
